// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.action-type-name,\n.el-table th.action-type-name {\n  width: 13em;\n}\n.el-table .el-tag {\n  width: 5.5em;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
